import { render, staticRenderFns } from "./TkBreadcrumbs.vue?vue&type=template&id=396285c8&scoped=true&"
import script from "./TkBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./TkBreadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./TkBreadcrumbs.vue?vue&type=style&index=0&id=396285c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396285c8",
  null
  
)

export default component.exports